<template>
  <div>
    <div :class="[$style.wrapper, !isOpen ? $style.hide : null]">
      <div v-if="this.isOpen" :class="$style.back" @click="backToCard">
        <img src="../assets/img/back.svg" alt="" />
      </div>
      <div :class="$style.photo">
        <swiper
          ref="swiper"
          :slidesPerView="1"
          :spaceBetween="10"
          :pagination="paginationParams"
          :autoplay="autoplayParams"
          class="swiper"
          @swiper="onSwiper"
        >
          <swiper-slide v-for="(photo, index) in photos" :key="index">
            <img :src="photo" alt="Photo" class="swiper-image" />
          </swiper-slide>
          <div v-if="this.photos.length > 1" class="custom-pagination">
            <div
              v-for="(photo, index) in photos"
              :key="index"
              class="pagination-dot"
              :class="{ active: currentSlide === index }"
              @click="goToSlide(index)"
            ></div>
          </div>
        </swiper>
      </div>

      <div :class="$style.content">
        <div :class="$style.title">
          <p :class="$style.tag">{{ this.object.category }} · ID {{ this.object.id }}</p>
          <p :class="$style.name">{{ this.object.header }}</p>
        </div>
        <p :class="$style.price">{{ formattedPrice }}</p>

        <p :class="$style.description" v-html="object.description"></p>

        <div :class="$style.buttons">
          <button
            v-if="isTelegram"
            @click="copyTelegramText"
            :class="[$style.button_transparent, linkCopied ? $style.buttonCopied : '']"
          >
            <img :class="$style.img" src="../assets/img/copy.svg" alt="" />
            {{ linkCopied ? 'Ссылка скопирована' : 'Скопировать ссылку' }}
          </button>

          <button @click="openSendBid" :class="$style.button">
            <img :class="$style.img" src="../assets/img/send.svg" alt="" />Отправить заявку
          </button>
        </div>
      </div>
      <div v-if="layouts.length" :class="$style.layouts">
        <p :class="$style.layouts_title">Планировки</p>
        <div :class="$style.layouts_row">
          <button
            v-for="(l, i) in layouts"
            :key="i"
            :class="$style.layout_item"
            @click="openLayouts(i)"
          >
            <span :class="$style.layout_thumb">
              <img :src="l.url" alt="Планировка" />
              <span v-if="l.discount" :class="$style.layout_disc">-{{ l.discount }}%</span>
            </span>
            <span :class="$style.layout_cap">{{ l.short || 'планировка' }}</span>
            <span v-if="l.object_id !== object.id" :class="$style.layout_sub">{{ l.header }}</span>
          </button>
        </div>
      </div>

      <div v-if="layoutsOpen" :class="$style.viewer" @click.self="layoutsOpen = false">
        <button :class="$style.viewer_close" @click="layoutsOpen = false">✕</button>
        <swiper
          :slidesPerView="1"
          :spaceBetween="16"
          :initialSlide="layoutIndex"
          class="layout-swiper"
          @swiper="onLayoutSwiper"
        >
          <swiper-slide v-for="(l, i) in layouts" :key="'v' + i">
            <div :class="$style.viewer_slide">
              <img :src="l.url" alt="Планировка" />
              <p :class="$style.viewer_kind">{{ l.short }}</p>
              <p v-if="l.final_price" :class="$style.viewer_price">
                <span v-if="l.discount" :class="$style.viewer_old">{{ money(l.price) }} ₽</span>
                {{ money(l.final_price) }} ₽
                <span v-if="l.discount" :class="$style.viewer_badge">Скидка {{ l.discount }}%</span>
              </p>
              <p v-if="l.building" :class="$style.viewer_meta">Корпус {{ l.building }}</p>
              <p v-if="l.floor" :class="$style.viewer_meta_s">Этаж {{ l.floor }}</p>
              <p v-if="l.view" :class="$style.viewer_meta_s">Вид {{ l.view }}</p>
              <p v-if="l.object_id !== object.id" :class="$style.viewer_caption">{{ l.header }}</p>
              <div :class="$style.viewer_actions">
                <button :class="$style.viewer_btn" @click="bidForLayout(l)">Оставить заявку</button>
                <button
                  :class="$style.viewer_copy"
                  @click="copyLayoutLink(l)"
                  aria-label="Скопировать ссылку"
                >
                  <svg
                    v-if="copiedLayout !== l.id"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7" />
                    <path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7" />
                  </svg>
                  <svg
                    v-else
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M5 12l5 5L20 7" />
                  </svg>
                </button>
              </div>
              <button
                v-if="l.object_id !== object.id"
                :class="$style.viewer_link"
                @click="goToObject(l.object_id)"
              >
                Открыть объект
              </button>
            </div>
          </swiper-slide>
        </swiper>
        <p :class="$style.viewer_counter">{{ layoutIndex + 1 }} / {{ layouts.length }}</p>
      </div>

      <p :class="$style.connection">Связаться с нами:</p>
      <div :class="$style.contacts">
        <button :class="[$style.contact_btn, $style.disabled]" disabled title="Скоро">
          <img src="../assets/img/max.svg" alt="MAX" />MAX
        </button>
        <button :class="$style.contact_btn" @click="openTelegram">
          <img src="../assets/img/telegram.svg" alt="Telegram" />Telegram
        </button>
      </div>
    </div>
    <SendBid
      v-if="sendBidOpen"
      :object="object"
      :link="bidLink"
      :layout-label="bidLayoutLabel"
      @backToOpenCard="closeSendBid"
    />
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import SendBid from './SendBid.vue';

export default {
  components: { Swiper, SwiperSlide, SendBid },
  data() {
    return {
      object: {},
      isOpen: true,
      sendBidOpen: false,
      isTelegram: false,
      photos: [],
      paginationParams: {
        clickable: true,
        type: 'bullets',
        dynamicBullets: true,
        renderBullet: (index, className) => {
          return `<span class="${className} custom-bullet"></span>`;
        },
      },
      autoplayParams: {
        delay: 3000,
        disableOnInteraction: false,
      },
      swiperInstance: null,
      currentSlide: 0,
      linkCopied: false,
      phoneCopied: false,
      link: '',
      layouts: [],
      layoutsOpen: false,
      layoutIndex: 0,
      copiedLayout: null,
      bidLink: '',
      bidLayoutLabel: '',
    };
  },
  async mounted() {
    try {
      const response = await fetch(`${window.location.origin}/api/object/${this.$route.params.id}`);
      if (response.ok) {
        this.object = await response.json();
      } else {
        alert('Object not found');
      }
    } catch (error) {
      console.error('Error fetching object:', error);
    }

    this.link = `${window.location.origin}/opencard/${this.object.id}`;

    for (let i = 0; i < this.object.photo_urls.length; i++) {
      this.photos.push(this.object.photo_urls[i]);
    }
    this.layouts = this.object.related_layouts || [];
    // ссылка на конкретную планировку: /opencard/<id>?layout=<layout_id>
    const wanted = Number(this.$route.query.layout);
    if (wanted) {
      const idx = this.layouts.findIndex((l) => l.id === wanted);
      if (idx >= 0) this.openLayouts(idx);
    }

    if (window.Telegram && window.Telegram.WebApp) {
      this.isTelegram = true;
    }
  },
  computed: {
    formattedPrice() {
      const p = this.object.price_from || this.object.price;
      if (p) {
        return (
          (this.object.has_layouts ? 'от ' : '') + new Intl.NumberFormat('ru-RU').format(p) + ' ₽'
        );
      }
      return '';
    },
  },
  methods: {
    backToCard() {
      this.isOpen = false;
      setTimeout(() => {
        const activeCategory = localStorage.getItem('activeCategory');
        if (activeCategory) {
          this.$router.push({ path: '/', query: { category: activeCategory } });
        } else {
          this.$router.push({ path: '/' });
        }
      }, 250);
    },
    openSendBid() {
      this.bidLink = this.link;
      this.bidLayoutLabel = '';
      this.sendBidOpen = true;
    },
    layoutLink(l) {
      return `${window.location.origin}/opencard/${l.object_id}?layout=${l.id}`;
    },
    bidForLayout(l) {
      this.layoutsOpen = false;
      this.bidLink = this.layoutLink(l);
      this.bidLayoutLabel = [
        l.short,
        l.building ? `корпус ${l.building}` : '',
        l.floor ? `этаж ${l.floor}` : '',
      ]
        .filter(Boolean)
        .join(', ');
      this.sendBidOpen = true;
    },
    async copyLayoutLink(l) {
      try {
        await navigator.clipboard.writeText(this.layoutLink(l));
        this.copiedLayout = l.id;
        setTimeout(() => {
          this.copiedLayout = null;
        }, 1500);
      } catch (e) {
        console.error(e);
      }
    },
    closeSendBid() {
      this.sendBidOpen = false;
    },
    async copyTelegramText() {
      if (this.isTelegram && window.Telegram && window.Telegram.WebApp) {
        await navigator.clipboard.writeText(this.link);
        this.linkCopied = true;
      }
    },
    onSwiper(swiper) {
      this.swiperInstance = swiper;
      swiper.on('slideChange', () => {
        this.currentSlide = swiper.activeIndex;
      });
    },
    goToSlide(index) {
      if (this.swiperInstance) {
        this.swiperInstance.slideTo(index);
      }
    },
    openTelegram() {
      // внутри мини-приложения обычные ссылки на t.me не открываются, нужен метод Telegram
      const url = 'https://t.me/XRealtybot';
      if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.openTelegramLink) {
        window.Telegram.WebApp.openTelegramLink(url);
      } else {
        window.open(url, '_blank');
      }
    },
    money(v) {
      return new Intl.NumberFormat('ru-RU').format(v);
    },
    openLayouts(i) {
      this.layoutIndex = i;
      this.layoutsOpen = true;
    },
    onLayoutSwiper(swiper) {
      swiper.on('slideChange', () => {
        this.layoutIndex = swiper.activeIndex;
      });
    },
    goToObject(id) {
      this.layoutsOpen = false;
      window.location.href = `/opencard/${id}`;
    },
  },
};
</script>

<style lang="scss" module>
@keyframes show {
  0% {
    left: -100%;
  }
  100% {
    left: 0;
  }
}
@keyframes hide {
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}
.wrapper {
  position: absolute;
  background: $background;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0 auto;
  animation: show 0.25s ease-in;
  &.hide {
    animation-name: hide;
    animation-duration: 0.26s ease-in;
  }
}
.photo {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 345px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.back {
  position: fixed;
  z-index: 2;
  top: 16px;
  left: 16px;
  width: 39px;
  height: 39px;
}
.content {
  padding: 24px;
}
.title {
  margin-bottom: 10px;
}
.name {
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: $white;
}
.tag {
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  color: $muted;
  margin-bottom: 4px;
}
.price {
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: $primary-light;
  margin-bottom: 10px;
}
.description {
  white-space: pre-wrap;
  word-wrap: break-word;
  text-align: start;
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  color: #d2d5da;
  margin-bottom: 32px;
}
.buttons {
  border-bottom: 1px solid #3a3a3a;
  padding: 0px 0px 32px 0px;
}
.button_transparent {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px 0px;
  width: 100%;
  background-color: transparent;
  color: $white;
  border: 1px solid #3a3a3a;
  border-radius: 12px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  margin-bottom: 16px;
}
.button {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px 0px;
  width: 100%;
  background-color: $primary;
  color: $white;
  border: none;
  border-radius: 12px;
  text-align: center;
  font-weight: 600;
  font-size: 13px;
  line-height: 15px;
}
.img {
  margin-right: 8px;
  width: 12px;
  height: 12px;
}
.connection {
  margin: 0 auto;
  margin-bottom: 16px;
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 26px;
  color: $muted;
}
.contacts {
  display: flex;
  gap: 8px;
  margin: 0 24px 40px;
}
.contact_btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: $bg-dark;
  border: none;
  border-radius: 12px;
  padding: 11px;
  color: $white;
  font-weight: 600;
  font-size: 13px;
  text-decoration: none;
  img {
    width: 20px;
    height: 20px;
  }
  &.disabled {
    opacity: 0.4;
  }
}
.layouts {
  padding: 0 24px;
  margin-bottom: 24px;
}
.layouts_title {
  font-size: 12px;
  color: $muted;
  margin-bottom: 10px;
}
.layouts_row {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}
.layout_item {
  flex: 0 0 auto;
  width: 96px;
  background: transparent;
  border: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.layout_thumb {
  position: relative;
  display: block;
  width: 96px;
  height: 96px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #3a3a3a;
  background: $white;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.layout_disc {
  position: absolute;
  top: 6px;
  left: 6px;
  background: $primary;
  color: $white;
  font-size: 9px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 6px;
}
.layout_cap {
  margin-top: 6px;
  font-size: 11px;
  font-weight: 600;
  color: $white;
  white-space: nowrap;
}
.layout_sub {
  font-size: 9px;
  color: $muted;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 96px;
}
.viewer_kind {
  margin-top: 12px;
  color: $muted;
  font-size: 12px;
}
.viewer_price {
  margin-top: 4px;
  color: $white;
  font-size: 20px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}
.viewer_old {
  color: $muted;
  font-size: 13px;
  font-weight: 400;
  text-decoration: line-through;
}
.viewer_badge {
  background: $primary;
  color: $white;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 8px;
}
.viewer_meta {
  margin-top: 6px;
  color: $white;
  font-size: 12px;
}
.viewer_meta_s {
  margin-top: 2px;
  color: $muted;
  font-size: 11px;
}
.viewer {
  position: fixed;
  inset: 0;
  z-index: 50;
  background: rgba(0, 0, 0, 0.94);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.viewer_close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 51;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: $bg-dark;
  color: $white;
  font-size: 16px;
}
.viewer_slide {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 16px;
  img {
    max-width: 100%;
    max-height: 52vh;
    object-fit: contain;
    border-radius: 12px;
    background: $white;
  }
}
.viewer_caption {
  margin-top: 12px;
  color: $white;
  font-size: 13px;
  text-align: center;
}
.viewer_actions {
  display: flex;
  gap: 8px;
  margin-top: 14px;
  width: 100%;
  max-width: 320px;
}
.viewer_btn {
  flex: 1;
  background: $primary;
  color: $white;
  border: none;
  border-radius: 12px;
  padding: 12px 18px;
  font-weight: 600;
  font-size: 13px;
}
.viewer_copy {
  flex: 0 0 46px;
  height: 46px;
  background: $bg-dark;
  color: $white;
  border: none;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.viewer_link {
  margin-top: 10px;
  background: transparent;
  border: none;
  color: $primary-light;
  font-size: 12px;
  font-weight: 600;
  text-decoration: underline;
}
.viewer_counter {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  color: $muted;
  font-size: 12px;
}
.buttonCopied {
  text-align: center;
  background-color: $primary;
  color: $white;
  border: 1px solid $primary;
  transition: all 0.2s ease-in-out;
}
</style>

<style lang="scss">
.swiper {
  height: 345px;
}
.layout-swiper {
  width: 100%;
  height: 80vh;
}
.custom-pagination {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.pagination-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.6);
  margin: 0 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.pagination-dot.active {
  background-color: $primary;
}
</style>
